module.exports = __webpack_public_path__ + "img/9788993313109.f8e74695.jpg";